export default function ProcessoPrevisivelSection() {
  const processos = [
    {
      titulo: 'Aquisição',
      descricao: 'Atrair pessoas realmente interessadas no seu produto.',
      icone: 'ri-user-add-line'
    },
    {
      titulo: 'Engajamento',
      descricao: 'Construir confiança e gerar interesse real.',
      icone: 'ri-chat-smile-3-line'
    },
    {
      titulo: 'Monetização',
      descricao: 'Transformar oportunidades em vendas.',
      icone: 'ri-money-dollar-circle-line'
    },
    {
      titulo: 'Retenção',
      descricao: 'Fazer clientes voltarem a comprar.',
      icone: 'ri-repeat-line'
    }
  ];

  return (
    <section className="py-16 lg:py-20 bg-white">
      <div className="container px-4">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-12 lg:mb-16">
            <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-gray-900 mb-4 lg:mb-6">
              Empresas que <span className="text-orange-600">vendem todos os dias</span> seguem um processo previsível
            </h2>
            <p className="text-lg lg:text-xl text-gray-700 leading-relaxed max-w-4xl mx-auto">
              A M4 Digital implementa um sistema que conecta aquisição, engajamento, vendas e retenção em um único fluxo de crescimento.
            </p>
          </div>

          <div className="grid lg:grid-cols-2 gap-12 lg:gap-16 items-center mb-12 lg:mb-16">
            <div className="order-2 lg:order-1">
              <div className="grid sm:grid-cols-2 gap-6">
                {processos.map((processo, index) => (
                  <div key={index} className="bg-gray-50 rounded-xl p-6 hover:shadow-lg transition-shadow">
                    <div className="w-12 h-12 bg-orange-100 rounded-lg flex items-center justify-center mb-4">
                      <i className={`${processo.icone} text-orange-600 text-2xl`}></i>
                    </div>
                    <h3 className="text-xl font-bold text-gray-900 mb-2">{processo.titulo}</h3>
                    <p className="text-gray-600">{processo.descricao}</p>
                  </div>
                ))}
              </div>
            </div>

            <div className="order-1 lg:order-2">
              <img 
                src="/images/ciclo.jpeg" 
                alt="Ciclo de Vendas Previsível" 
                className="w-full rounded-2xl shadow-xl"
              />
            </div>
          </div>

          <div className="bg-gradient-to-r from-orange-50 to-red-50 rounded-2xl p-8 lg:p-12 text-center">
            <p className="text-lg lg:text-xl text-gray-800 leading-relaxed font-medium">
              Quando essas quatro etapas funcionam juntas, seu negócio para de depender da sorte e passa a crescer com <span className="text-orange-600 font-bold">previsibilidade</span>.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
